import { LoginTrackingPoint } from '@shopee-user/tracking-constants';

import { PageType } from '../constants';

const LoginTrackingSchema: Record<LoginTrackingPoint, string> = {
  [LoginTrackingPoint.PageView]: 'fb757ff9-e0ec-4a83-827f-82b30bcf4bb2',
  [LoginTrackingPoint.LoginButtonClick]: '5e2ef912-18da-4709-983e-3b46c4592f3b',
  [LoginTrackingPoint.ForgotButtonClick]:
    '98f28a70-d751-4119-ab12-5757942a7395',
  [LoginTrackingPoint.HelpButtonClick]: 'b6fbfa71-f454-446a-8a7f-8cf419056c3e',
  [LoginTrackingPoint.BackButtonClick]: '72080792-8ae5-4f6e-bdd0-d08bb2fafc9e',
  [LoginTrackingPoint.SignupButtonClick]:
    'ec0fa6ee-62bb-4f14-934b-10a33d1d9442',
  [LoginTrackingPoint.LoginSuccessAction]:
    '18ce11ad-7146-4e42-9bf3-9951730f1613',
  [LoginTrackingPoint.LoginFailAction]: '',
  [LoginTrackingPoint.LoginFailedToastAction]: '',
  [LoginTrackingPoint.LoginWithSMSButtonClick]:
    '047d7a25-9400-4eb2-a631-b72edbeef6f6',
  [LoginTrackingPoint.LoginWithSMSNextButtonClick]:
    '3289b103-2b08-4f4d-a637-7e403791dc69',
  [LoginTrackingPoint.LoginWithSMSLoginWithPasswordButtonClick]:
    'ba70408a-c1d5-47d7-9d27-1e2c299cc94e',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupImpression]:
    '89669169-011e-455e-86e4-67370b0c0d69',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupOkButtonClick]:
    'a5dbf5f3-7338-45e4-a188-c06c992993a0',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupRefreshButtonClick]:
    'b82e77eb-aa28-4cc8-b565-50bfe5ead009',
  [LoginTrackingPoint.LoginWithSMSCaptchaPopupCancelButtonClick]:
    '1fb4a9d2-5e22-4ff6-9d75-c3d15a8b3529',
  [LoginTrackingPoint.LoginWithPasswordAddPhoneEmailPopupView]: '',
  [LoginTrackingPoint.LoginWithPasswordAddPhoneEmailPopupOkClick]: '',
  [LoginTrackingPoint.LoginWithThirdPartyGoogle]: '',
  [LoginTrackingPoint.LoginWithThirdPartyFacebook]: '',
  [LoginTrackingPoint.LoginWithThirdPartyApple]: '',
  [LoginTrackingPoint.LoginWithThirdPartyShopee]: '',
  [LoginTrackingPoint.LoginByTokenSuccessAction]: '',
  [LoginTrackingPoint.QuickLoginToggleImpression]:
    '5030f3ab-26f7-4ff3-ab99-55a4e02735d6',
  [LoginTrackingPoint.QuickLoginToggleClick]:
    '51af7e84-d42b-4b7b-84b3-01df973b7372',
  [LoginTrackingPoint.QuickLoginTooltipImpression]:
    'b317dd16-3e7c-4f69-85bb-768cc6659676',
  [LoginTrackingPoint.QuickLoginActionSuccess]:
    '237a5ea8-99fa-4af3-89e2-bf6da44a2ed8',
  [LoginTrackingPoint.LoginWithBusinessGoogleButtonClick]: '',
};

export const getLoginPageTypeAndSchema = (
  trackingPoint: LoginTrackingPoint
) => {
  return {
    page_type: PageType.LoginPage,
    schema: LoginTrackingSchema[trackingPoint],
  };
};
